/** A POJO that stores constants of use to different plugins, modules, etc.
 */

'use strict';

/** Online store ID
 *  @deprecated
 */
exports.STOREID = 8000;

/** SKUs
 */
exports.SKUS = {
    GIFT_CARD: '9990490006',
    MEMBERSHIP: '6485920018'
};

/** Gift Card Media Codes
 */
exports.MEDIA_CODES = {
    GIFT_CARD: 'GC',
    E_CARD: 'EC',
    PROMO_CARD: 'P'
};

/** RegExp cache
 */
exports.RE = {
    CLEAN_URL_CHARS: /[;'<>=()]/gm
};

/** Validation Patterns
 */
exports.VALIDATION_PATTERNS = {
    PERSONTITLE: /\d|\w|\s|-|'|\./,
    PERSONSUFFIX: /\d|\w|\s|-|'|\./,
    FIRSTNAME: /^([A-Za-z0-9]|\s|-|'|\.)*$/,
    MIDDLEINITIAL: /^[A-Za-z]{1}$/,
    LASTNAME: /^([A-Za-z0-9]|\s|-|'|\.)*$/,
    ADDRESS1: /\d|\w|\s|-|'|\.|@|#|\+|&|%|\//,
    ADDRESS2: /\d|\w|\s|-|'|\.|@|#|\+|&|%|\//,
    ADDRESS3: /\d|\w|\s|-|'|@|#|\+|&|%|!|\$|\//,
    CITY: /\d|\w|\s|-|'|@|#|\+|&|%|\//,
    ZIPCODE: /(?:\d|\s|[a-zA-Z]|-|[A-Z]+)/,
    ZIPCODEINTL: /^[0-9a-zA-Z\/]+(?:[-\\s][0-9a-zA-Z]+)?$/,
    ZIPCODENA: /(N\/A)|(N\\\A)|(NA)/i,
    USZIPCODE: /^\d{5}$|^\d{5}-\d{4}$|^\d{9}$/,
    PHONENUMBER: /^[^,]*$/,
    USPHONENUMBER: /^[\d\-\(\)\sx\+]+$/,
    MATCH_PHONE_NON_NUMBERS: /\(|\)|\s|\-|[a-zA-Z]/g,
    EMAIL: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
    EXCLUDE_AND: /(\band\b)/i,
};

exports.GIFT_CARDS = {
    NUMBER: /^\d{12}$|^\d{19}$/,
    PIN: /^\d{4}$/
};

/** Error Messages
 */
exports.ERROR_MESSAGES = {
    INVALID_USZIPCODE: 'Please enter a valid zip code.',
    INVALID_USPHONENUMBER: 'Please enter a valid phone number, including area code.',
    INVALID_INTLPHONENUMBER: 'Please enter a valid phone number, including country and city code.',
    INVALID_CHARACTER: 'This field has invalid characters in it.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    REQUIRED_FIELD: 'This field is required.',// TODO this message name needs to be deprecated and replaced with, ERR_REQUIRED_FIELDS_EMPTY
    ERR_REQUIRED_FIELDS_EMPTY: 'This field is required.',
    EMAIL_ALREADY_TAKEN: 'The email address you entered is already associated with a different REI account. Please enter an alternate email address.',
    MULTIPLE_MEMBERSHIP_ITEMS_REMOVED_MEMBER: 'Our records indicate that you\'re an REI member. REI members may not order additional memberships online. We\'ve removed the additional membership(s) from your cart. To purchase a gift membership, please call 1-800-426-4840 or visit your local REI store.',
    MULTIPLE_MEMBERSHIP_ITEMS_REMOVED_NON_MEMBER: 'We\'re sorry, but you cannot order more than one REI membership online. We’ve removed the additional membership(s) from your cart. To purchase a gift membership, please call 1-800-426-4840 or visit your local REI store.',
    INVALID_CARD_NUMBER: 'The credit card number you entered is in an incorrect format. Please check your card and try again.',
    INVALID_CARD_EXPIRATION_DATE: 'Your expiration date is invalid. Please check your card and try again.',
    INVALID_SAVED_CARD_EXPIRATION_DATE: 'Your expiration date is invalid. Please check your card and try again. Any updates will overwrite this saved credit card.',
    INVALID_CARD_CODE: 'The card security code is incorrect or the field is blank. Please check your card and try again.',
    INVALID: '(FPO) INVALID',
    INVALID_GIFT_CARD_NUMBER: 'Must be 12 or 19 numbers.',
    INVALID_GIFT_CARD_PIN: 'Must be 4 numbers.',
    TAX_ISSUE: 'Tax could not be calculated at this time. Tax will be added to the total due before your order payment is processed.'
};

/** REI.com rest service error code
 */
exports.REST_ERROR_CODES = {
    CHECKOUT_TIMEOUT: 3438
};

/** Country codes
 */
exports.COUNTRY_CODES = {
    UNITEDSTATES: 'United States',
    CANADA: 'Canada'
};
